export function ClientSecret() {
  return {
    dev: 'y_m0L1cLWKrb6R3r46rvZw3XW9ka',
    'ec2-integration': 'tqXjB6QlPPLzJdkM7TQM7NtFlFIa',
    'ec2-qa': '4CQpJGX77dfkZv_yZoPS8vjxgFEa',
    'ec2-uat': 'DeYOTUM_wfGgqE13mQyJcrqCeDAa',
    'eks-preprod': 'r4QIIjm5eEJqqK7Sbn9zUtROwSEa',
    'eks-prod': 'iMxhV1EGWooEeyET_edbHCrNxJAa',
    preprod: 'Pgu4ywAuXjyLnGu_I7k1vbDYLZAa',
  };
}
